module.exports = {"411103001":"沙北街道","411103100":"城关镇","411103101":"孟庙镇","411103102":"商桥镇","411103103":"裴城镇","411103104":"新店镇","411103105":"龙城镇","411103106":"李集镇","411103107":"黑龙潭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411103.json
// module id = 1485
// module chunks = 0